// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"BgVideo_bgVideoWrapper__U3-3k"};